import "./mock";
import Vue from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import store from "./store/index";
store.dispatch("setting/getData");
Vue.config.productionTip = false;

import vloading from "./directive/loading";
Vue.directive("loading", vloading);

import vlazy from "./directive/lazy";
Vue.directive("lazy", vlazy);

new Vue({
  store,
  render: (h) => h(App),
  router,
}).$mount("#app");
